import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Filter } from '../models/filter-models';
import { CustomTieringModeDialogComponent } from '../common/custom-tiering-mode-dialog/custom-tiering-mode-dialog.component';

@Component({
  selector: 'app-custom-cluster-jewel-tiering-mode-dialog',
  imports: [CustomTieringModeDialogComponent],
  template: `<app-custom-tiering-mode-dialog kind="clusterJewel" [filter]="filter" (close)="close.emit()" />`,
})
export class CustomClusterJewelTieringModeDialogComponent {
  @Input({ required: true }) filter!: Filter;
  @Output() close = new EventEmitter<void>();
}
